import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  private apiUrl = '';
  private table  = 'GROUP_AIRPORT';  // default for the group_airport table
  private tableUrl = '';

  constructor(private http: HttpClient) {
    this.apiUrl = 'https://fligence.com:8181/api/'; // constant URL to web api
    this.tableUrl = this.apiUrl + this.table;
  }

  setTable(table: string) {
    this.table = table;
    this.tableUrl = this.apiUrl + this.table;
  }

  getTable(): Observable<any[]> {
    console.log(this.tableUrl);
    return this.http.get<any[]>(this.tableUrl)
        .pipe(
            tap(_ => console.log('fetched table')),
            catchError(this.handleError<Object[]>('getTable', []))
        );
  }

  getRecord(id: number): Observable<{[key: string]: any}> {
    const url = `${this.tableUrl}/${id}`;
    console.log(url);
    return this.http.get<Object>(url).pipe(
      tap(_ => console.log(`fetched record id=${id}`)),
      catchError(this.handleError<Object>(`getRecord id=${id}`))
    );
  }

  saveResult(result: {[key: string]: any}): Observable<Object>{
    const config = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    let apiUrl = this.tableUrl;
    if (result.ID) {
      apiUrl += '/update/' + result.ID;
      return this.http.put<Object>(apiUrl, result as Object, config)
      .pipe(
        catchError(this.handleError<Object>('saveRecord', result))
      )
    }
    else {
      apiUrl += '/add';
      return this.http.post<Object>(apiUrl, result as Object, config)
      .pipe(
        catchError(this.handleError<Object>('saveRecord', result))
      )
    }
  }

  deleteResult(result: {[key: string]: any}): Observable<Object>{
    const config = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    let apiUrl = this.tableUrl +  '/delete/' + result.ID;
    return this.http.delete(apiUrl)
        .pipe(
            catchError(this.handleError<Object>('deleteRecord', result))
        )
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log to console instead

      return of(result as T);
    };
  }
}
